import React, { useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { PawIcon } from "@/components/Icons";
import { joinWaitlist } from "@/lib/api";
import { toast } from "sonner";
import { Baby } from "lucide-react";
import Reveal from "@/components/Reveal";

const WaitlistBanner = () => {
  const { t } = useLang();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim()) return;
    setSubmitting(true);
    try {
      await joinWaitlist({ name: name.trim(), email: email.trim() });
      toast.success(t.banner.success);
      setDone(true);
      setName("");
      setEmail("");
    } catch (err) {
      if (err?.response?.status === 409) {
        toast.error(t.banner.already);
      } else {
        toast.error(t.contact.error);
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="py-8 px-5 sm:px-8" data-testid="waitlist-banner">
      <div className="max-w-5xl mx-auto">
        <Reveal>
          <div className="banner-honey rounded-3xl p-6 sm:p-8 flex flex-col md:flex-row md:items-center gap-6 relative overflow-hidden">
            <div className="absolute -right-6 -top-6 opacity-20 pointer-events-none">
              <PawIcon size={120} className="text-[#6b3f2a]" />
            </div>

            <div className="flex items-center gap-4 md:gap-5 flex-1">
              <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-white shadow-md flex items-center justify-center shrink-0">
                <Baby size={28} className="text-[#f4956a]" />
              </div>
              <div className="flex-1">
                <h3 className="font-display text-xl sm:text-2xl text-[#6b3f2a] flex items-center gap-2">
                  🍼 {t.banner.title}
                </h3>
                <p className="text-sm sm:text-base text-[#6b3f2a]/85 mt-1 leading-snug">
                  {t.banner.text}
                </p>
              </div>
            </div>

            <form
              onSubmit={submit}
              className="w-full md:w-auto md:max-w-md flex flex-col sm:flex-row gap-2"
              data-testid="waitlist-form"
            >
              <input
                type="text"
                placeholder={t.banner.namePh}
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="cute-input bg-white/90 min-w-0 sm:w-40"
                required
                data-testid="waitlist-name"
                aria-label={t.banner.namePh}
              />
              <input
                type="email"
                placeholder={t.banner.emailPh}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="cute-input bg-white/90 min-w-0 sm:w-52"
                required
                data-testid="waitlist-email"
                aria-label={t.banner.emailPh}
              />
              <button
                type="submit"
                disabled={submitting}
                className="btn-primary justify-center whitespace-nowrap"
                data-testid="waitlist-submit"
              >
                {submitting ? "…" : t.banner.submit}
              </button>
            </form>
          </div>
          {done && (
            <p className="text-center mt-3 text-[#6b3f2a] font-semibold" data-testid="waitlist-success">
              {t.banner.success}
            </p>
          )}
        </Reveal>
      </div>
    </section>
  );
};

export default WaitlistBanner;
